import MuiBackdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useStyles } from './style';

interface Props {
  open: boolean;
}

const Backdrop: React.FC<Props> = ({ open }) => {
  const classes = useStyles();

  return (
    <MuiBackdrop open={open} className={classes.backdrop}>
      <CircularProgress color="inherit" />
    </MuiBackdrop>
  );
};

export default Backdrop;
